import * as ToggleMenuFlyout from '@ori-events/toggle-menu-flyout';
import { Box, CircularProgress, Modal, Slide, styled, useTheme } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';
import { lazy, Suspense, useCallback } from 'react';

import { CSS_DESKTOP_HEIGHT } from '../../constants';
import { useActiveMenu } from '../../context/navigation';
import { useIsMobile } from '../../hooks';

const AccountFlyoutRoot = styled('div')(({ theme }) => ({
  background: theme.palette.common.white,
  height: '100%',
  paddingTop: CSS_DESKTOP_HEIGHT,
  position: 'absolute',
  width: 280,
}));

const AccountLazy = lazy(async () => import('./LoginLibrary')) as FC;

const fallback = (
  <Box
    display="flex"
    justifyContent="center"
  >
    <CircularProgress />
  </Box>
);

export const AccountFlyout: FC = () => {
  const { activeMenu, toggleActiveMenu } = useActiveMenu();
  const isMobile = useIsMobile();
  const { getTestId } = useTestId();
  const { zIndex } = useTheme();
  const handleModalClose = useCallback(
    () => toggleActiveMenu(ToggleMenuFlyout.MenuTypes.AccountSideMenu),
    [toggleActiveMenu],
  );
  const isAccountMenuActive = !isMobile && activeMenu === ToggleMenuFlyout.MenuTypes.AccountSideMenu;

  return (
    <Modal
      style={{ zIndex: zIndex.modal }}
      open={isAccountMenuActive}
      data-testid={getTestId('account-flyout-modal')}
      onClose={handleModalClose}
    >
      <Slide
        in={isAccountMenuActive}
        direction="right"
      >
        <AccountFlyoutRoot>
          <Suspense fallback={fallback}>
            <AccountLazy />
          </Suspense>
        </AccountFlyoutRoot>
      </Slide>
    </Modal>
  );
};
